import React from 'react';

const HandShake = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9143 31.5059H2.83093V12.7559H25.7476L29.9143 31.5059Z"
        fill="#FFE7C4"
      />
      <path
        d="M20.7267 45.235L6.99756 31.5059L25.7476 12.7559L39.4767 26.485C40.2528 27.2657 40.6884 28.3217 40.6884 29.4225C40.6884 30.5234 40.2528 31.5794 39.4767 32.36L26.6017 45.235C25.8211 46.0111 24.7651 46.4467 23.6642 46.4467C22.5634 46.4467 21.5074 46.0111 20.7267 45.235Z"
        fill="#FFE7C4"
      />
      <path
        d="M31.4568 9.21411C30.4668 8.81984 29.3634 8.81984 28.3734 9.21411L19.7484 12.7558C19.2537 12.9407 18.8031 13.2268 18.4254 13.5959C18.0478 13.9651 17.7514 14.409 17.5552 14.8993C17.3591 15.3897 17.2676 15.9156 17.2865 16.4433C17.3054 16.9711 17.4343 17.4891 17.6651 17.9641C18.1198 18.9372 18.9327 19.6971 19.9342 20.0853C20.9356 20.4735 22.0484 20.4599 23.0401 20.0474L29.9151 16.9224L39.4776 26.4849C40.2536 27.2656 40.6893 28.3216 40.6893 29.4224C40.6893 30.5233 40.2536 31.5793 39.4776 32.3599L36.1651 35.6724H48.6651V8.58911L40.3318 12.7558L31.4568 9.21411Z"
        fill="#FFC49A"
      />
    </svg>
  );
};

export default HandShake;
